import React, { useEffect } from "react";
import { decoded } from "../Utils/UserProfile";
import { useNavigate } from "react-router";
import PharmaData from "../components/PharmaData";

const Pharma = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (decoded === null) {
      window.location.href = "/";
    }
  }, [decoded]);
  return (
    <div className="innerContainer">
      <div className="dashboardPage">
        <PharmaData />
      </div>
    </div>
  );
};

export default Pharma;
